import {
    LaneFeesStatus,
} from 'app/enums/label.enums'

export const QUOTATION = 'Quotation'
export const EXECUTION = 'Execution'

export type PrintFilterValues = {
    restrictAirports: boolean,
    selectedAirports: number[],
    customerType: typeof EXECUTION | typeof QUOTATION,
    selectedCustomerExecution: string,
    selectedLaneFeesStatuses: LaneFeesStatus[],
    selectedLaneStatus: string,
    exactDates: boolean,
    laneFeeValidFrom: string,
    laneFeeValidTo: string,
    isCustomerQuotation: boolean,
    allowDuplication: boolean,
    comment: string,
}

export type ContactsSelection = {
    skyCellContact: {id: number},
    customerQuotationContact?: string,
    customerExecutionContact?: string,
}
